export const ListSortItemValue = {
  RANK: 'rank',
  PUBLISHED_AT: 'published_at',
  PRICE: 'price',
  RATING: 'rating',
  DISCOUNT: 'discount',
};
